import React, { useState, useEffect } from "react";
// import { Container } from 'reactstrap'
import Breadcrumbs from "../components/Common/Breadcrumb";
import {
  Container,
  Card,
  CardBody,
  CardTitle,
  Col,
  Row,
  Badge,
  Button,
} from "reactstrap";
import DropdownWithTwoField from "../customComponents/DropdownWithTwoField";
import dayjs from "dayjs";
// import DataTable from "../customComponents/DataTable";
import { lineStyle, dropdownOptions, dropdownOptions2 } from "../data/Data";
import DropDownHeader from "../customComponents/DropDownHeader";
import { useSelector, useDispatch } from "react-redux";
import {
  Shortlistedjobsdata,
  addCandidatesLocation,
  addCandidatesSkills,
  getFilterJobsByStatus,
} from "./PartnerSlice";
import CustomTable from "../customComponents/reactTable/CustomTable";
import "../../src/assets/css/styleCompanyBench.css";
import DetailsCanvas from "../customComponents/offcanvas/CanvasJobdescription";
import { Link } from "react-router-dom";
import { log_debug } from "../apiHelpers/logger";
import CanvasPartnerJobDetails from "../customComponents/offcanvas/CanvasPartnerJobDetails";
import { Tags } from "../pages/Contacts/ContactList/contactlistCol";
import NodataFoundTable from "../customComponents/utilities/NodataFoundTable";
import Customloading from "../customComponents/Customloading/Customloading";
import CustomBreadcrumb from "../customComponents/breadcrumb/CustomBreadcrumb";
import { dateyyyymmdd_tohtml } from "../helpers/date";
import JobsBadge from "../customComponents/utilities/JobsBadge";

function Shortlistedjobs() {
  //PAGINATION
  const [currentPage, setCurrentPage] = useState(0);

  const [Shortlistjobs, setShortlistjobs] = useState([]);
  const [Shortlistjobscount, setShortlistjobscount] = useState([]);

  const [Shortlistjobsloading, setShortlistjobsloading] = useState(true);
  const [Skills, setSkills] = useState([]);
  const [Location, setLocation] = useState([]);
  const [isOffcanvasOpen, setOffcanvasOpen] = useState(false);
  const [selectedCandidate, setSelectedCandidate] = useState(null);

  const [selectedTechnology, setSelectedTechnology] = useState([]);
  const [selectedLocations, setSelectedLocations] = useState([]);
  const [filtervalue, setFiltervalue] = useState("");

  // const count = Shortlistjobs.length;
  const dispatch = useDispatch();
  const partnerStore = useSelector((state) => state.partnerSlice);
  const loadingdata = useSelector(
    (state) => state?.partnerSlice?.status === "loading",
  );

  const yourDynamicHeaderData = {
    full_name: "full_name",
    email: "email",
    contact_no: "contact_no",
    skills: "skills",
    prefered_locations: "prefered_locations",
    experience: "experience",
  };

  // function capitalizeWords(str) {
  //   return str.replace(/_/g, ' ').replace(/\b\w/g, (char) => char.toUpperCase());
  // }
  const columns = [
    {
      Header: "Jobs",
      accessor: "title",
      Cell: ({ row }) => (
        <Link
          to={"#"}
          onClick={() => {
            candidateName(row.original);
          }}
        >
          {row.values.title}
        </Link>
      ),
    },
    {
      Header: "Location",
      accessor: "location",
      Cell: ({ row }) => (
        <div className="">
          {row.original.location.length >= 1
            ? row.original.location.join(", ")
            : "-"}
        </div>
      ),
    },

    {
      Header: "Date",
      accessor: "updatedAt",
      // Cell: (props) => {
      //   const tidyDate = dayjs(props.value).format("DD-MMM-YYYY");
      //   return <span>{tidyDate}</span>;
      // },
      Cell: ({ value }) => (value ? dateyyyymmdd_tohtml(value) : "-"),
    },
    {
      Header: "Skills",
      accessor: "skills",
      Cell: (cellProps) => {
        return <Tags {...cellProps} />;
      },
      // Cell: ({ value }) => value.join(", "),
      // Cell: ({ value }) => (
      //   <div>
      //     {/* <div style={{ whiteSpace: "normal", height: "auto" }}> */}
      //     {value.map((tech, index) => (
      //       <Badge
      //         key={index}
      //         color="primary"
      //         className="bg-primary text-white m-1"
      //       >
      //         {tech}
      //       </Badge>
      //     ))}
      //   </div>
      // ),
    },
    {
      Header: "Experience",
      accessor: "minExperience",
      Cell: ({ row }) => (
        <div className="">
          {row.original?.minExperience ? row.original?.minExperience : 0}
        </div>
      ),
      // Cell: ({ value }) => <JobsBadge status={value} />,
    },
    {
      Header: "Created Date",
      accessor: "createdAt",
      Cell: (props) => {
        const tidyDate = dayjs(props.value).format("YYYY-MM-DD");
        return <span>{tidyDate}</span>;
      },
    },
    // {
    //   Header: "Status",
    //   accessor: "status",
    //   Cell: ({ value }) => <JobsBadge status={value} />,
    // },

    // Add more columns as needed
  ];
  useEffect(() => {
    if (partnerStore.status === "idle") {
      if (
        partnerStore.data.CandidatesSkills?.success === true &&
        partnerStore.data.CandidatesLocation?.success === true
      ) {
        setSkills(partnerStore.data.CandidatesSkills?.data?.enumskills);
        setLocation(partnerStore.data.CandidatesLocation?.data?.enumcitys);
      } else {
        dispatch(addCandidatesSkills());
        dispatch(addCandidatesLocation());
      }
    }
  }, []);

  useEffect(() => {
    if (partnerStore.status === "idle") {
      if (partnerStore.data.ShortlistedjobsRecords?.success === true) {
        setShortlistjobsloading(false);
        setShortlistjobs(partnerStore.data.ShortlistedjobsRecords?.data?.jobs);
        setShortlistjobscount(
          partnerStore.data.ShortlistedjobsRecords?.data?.totalCount,
        );
      } else if (partnerStore.data.ShortlistedjobsRecords?.success === false) {
        setShortlistjobsloading(false);
        setShortlistjobs([]);
        setShortlistjobscount(0);
      }
      if (partnerStore.data.CandidatesSkills?.success === true) {
        setSkills(partnerStore.data.CandidatesSkills?.data?.enumskills);
      }
      if (partnerStore.data.CandidatesLocation?.success === true) {
        setLocation(partnerStore.data.CandidatesLocation?.data?.enumcitys);
      }
    }
  }, [
    partnerStore.data.ShortlistedjobsRecords,
    partnerStore.data.CandidatesSkills,
    partnerStore.data.CandidatesLocation,
  ]);

  const skillOptions = Skills.map((item) => ({
    value: item.code,
    label: item.title,
  }));

  const locationOptions = Location.map((item) => ({
    value: item.code,
    label: item.title,
  }));

  const candidateName = (guid) => {
    setSelectedCandidate(guid);
    setOffcanvasOpen(true);
  };

  const closeOffcanvas = () => {
    setOffcanvasOpen(false);
    // setisOffcanvasOpenBGV(false);
  };

  const handleTechnologyChange = (selectedOptions) => {
    const selectedValues =
      selectedOptions && selectedOptions?.map((option) => option?.label);
    setSelectedTechnology(selectedValues);
  };
  const handleLocationChange = (selectedOptions) => {
    const selectedValues =
      selectedOptions && selectedOptions?.map((option) => option?.label);
    setSelectedLocations(selectedValues);
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      dispatch(
        Shortlistedjobsdata({
          skills: selectedTechnology ? selectedTechnology : "",
          locations: selectedLocations ? selectedLocations : "",
          currentPage: currentPage ? currentPage : 0,
          filtervalue: filtervalue ? filtervalue : "",
        }),
      );
    }, 700);

    return () => clearTimeout(timer);
  }, [selectedTechnology, selectedLocations, currentPage, filtervalue]);

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
  };

  const handleValueChange = (newValue) => {
    setShortlistjobsloading(true);
    setFiltervalue(newValue);
  };

  const breadcrumbValues = ["Shortlisted jobs"];

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          {/* Render Breadcrumbs */}
          <CustomBreadcrumb values={breadcrumbValues} />
          <div className="col-lg-12">
            <>
              <div className="row">
                <div className="col-lg-12">
                  <div>
                    {/* <Card
                    style={{
                      backgroundColor: "#5156BE",
                      paddingTop: "15px",
                    }}
                    >
                  <CardBody> */}
                    <Row>
                      <div className="col-12 col-lg-6 col-md-6 d-sm-flex">
                        <div className="col-12 col-lg-6">
                          <DropdownWithTwoField
                            // label="Option 1"
                            options={skillOptions}
                            placeholder="Select Technology"
                            onSelectChange={handleTechnologyChange}
                          />
                        </div>{" "}
                        &nbsp;
                        <div className="col-12 col-lg-6">
                          <DropdownWithTwoField
                            options={locationOptions}
                            placeholder="Select locations"
                            onSelectChange={handleLocationChange}
                          />
                        </div>
                      </div>
                      <div className="col-12 col-lg-6 col-md-6">
                        <Col md={12}>
                          <CardTitle className="page-title text-muted">
                            <span>Total count : </span>
                            <strong>
                              {Shortlistjobscount ? Shortlistjobscount : 0}
                            </strong>
                          </CardTitle>
                        </Col>
                      </div>
                    </Row>
                    {/* </CardBody> */}
                    {/* </Card> */}
                  </div>
                  <div>
                    <Card>
                      <CardBody>
                        <CustomTable
                          totalCount={Shortlistjobscount}
                          columns={columns}
                          data={Shortlistjobs?.length >= 1 ? Shortlistjobs : []}
                          hideCheckbox={true}
                          isLoading={Shortlistjobsloading}
                          currentPage={currentPage}
                          onPageChange={handlePageChange}
                          onChange={handleValueChange}
                          globalsearch={true}
                        />
                      </CardBody>
                    </Card>
                  </div>
                </div>
              </div>
            </>
          </div>
        </Container>
      </div>
      {isOffcanvasOpen && (
        <CanvasPartnerJobDetails
          shortlistedstatus={true}
          data={selectedCandidate}
          width={50}
          placement="end"
          usertype={"partner"}
          isOpen={isOffcanvasOpen}
          toggle={() => setOffcanvasOpen(!isOffcanvasOpen)}
          onclose={closeOffcanvas}
        />
      )}
    </React.Fragment>
  );
}

export default Shortlistedjobs;
